<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="toc"><a id="page_viii"></a><img alt="Images" src="images/contents.jpg"/></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch01#ch01">1 Taking the Medicine</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02#ch02">2 Half Truths</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch03#ch03">3 The Gift</a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4 Confessions</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5 Pure Chemistry</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6 The Avenging Love</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7 A Date and Destiny</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8 Birth</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9 Rebirth</span></p>
<p class="toc"><a id="page_ix"></a><span class="nounder" href="#/xhtml/ch10#ch10" title="Link target outside of Sample">10 Life as a Succubus</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11#ch11" title="Link target outside of Sample">11 A Bad Hair Day</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12#ch12" title="Link target outside of Sample">12 A Lesson in the Elements</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13#ch13" title="Link target outside of Sample">13 The Fifth Element</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14#ch14" title="Link target outside of Sample">14 Voodoo Child</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch15#ch15" title="Link target outside of Sample">15 Catalyst</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch16#ch16" title="Link target outside of Sample">16 Exorcising Independence</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch17#ch17" title="Link target outside of Sample">17 Straight to Hell</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch18#ch18" title="Link target outside of Sample">18 Trip Trap</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch19#ch19" title="Link target outside of Sample">19 Healing</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6d400fb8